export default __webpack_public_path__ + "images/models/301e46f5bd672f350685b822119952de.usdz";